import PropTypes from 'prop-types';
import ReactDropzone from 'react-dropzone';
import { v4 as uuid } from 'uuid';
import Notification from '../../Utils/Notification';
import UploaderFile from './UploaderFile';
import { uploadFile, deleteFile } from '../../../services/frontend';
import '../../../styles/dropzone.scss';
import { Component, Fragment } from 'react';
import { ReactComponent as IconPlus } from '../../../icons/icon-plus.svg';
import { FormattedMessage } from 'react-intl';
import { ReactComponent as BinIcon } from '../../../icons/icon_delete_bin.svg';

const appFsoBackendUrl = window.env.APP_BROKERFRONT_FSO_BACKEND_URI;

class Dropzone extends Component {
  constructor(props) {
    super(props);

    this.state = { files: [], paths: [] };

    this.onDrop = this.onDrop.bind(this);
    this.removeFile = this.removeFile.bind(this);
    this.logoType = this.props.uploadParams.logoType || 'default';
    this.showLogoFromFileId = true;
    this.actualFileId = this.props.fileId;
    this.actualLogoAlreadyDeleted = false;
  }

  onDrop(files) {
    let newFiles = [];

    files.map((file) => {
      const uid = uuid();

      if (file.name.length > 255) {
        Notification({
          type: 'error',
          text: 'Za długa nazwa pliku',
        }).show();
        return null;
      }

      let formData = new window.FormData();
      const uploadParams = this.props.uploadParams;

      formData.append('companyLogo', file);
      formData.append('product', uploadParams.product);
      formData.append('logoType', this.logoType);

      newFiles.push({
        name: file.name,
        size: file.size,
        type: file.type,
        progress: 0,
        status: 'loading',
        uid,
      });

      const uploadCallback = (progressEvent) => {
        const index = this.state.files.findIndex((item) => item.uid === uid);
        let oldFile = { ...this.state.files[index] };
        oldFile = {
          ...oldFile,
          progress: progressEvent.loaded / progressEvent.total,
        };

        const fs = [...this.state.files];
        fs[index] = oldFile;

        this.setState({
          files: fs,
        });
      };

      const uploadConfig = {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: uploadCallback,
      };

      return uploadFile(formData, this.props.url, uploadConfig)
        .then(async (response) => {
          Notification({
            type: 'success',
            text: `Plik ${file.name} został wgrany poprawnie`,
          }).show();
          const { data } = response;

          if (data?.logoId) this.props.addFile(data.logoId);

          const index = this.state.files.findIndex((item) => item.uid === uid);
          let oldFile = { ...this.state.files[index] };
          oldFile = {
            ...oldFile,
            filename: oldFile.name,
            fileId: data.logoId,
            type: this.props.fileType,
            status: 'success',
          };
          const fs = [...this.state.files];
          fs[index] = oldFile;

          this.setFiles(fs);

          const fileReader = new FileReader();
          const preview = document.getElementById(`file-preview-${this.logoType}`);

          fileReader.onload = (event) => {
            if (preview) preview.setAttribute('src', event.target.result);
          };
          fileReader.readAsDataURL(file);
        })
        .catch((err) => {
          if (!err.response || (err.response && err.response.status === 500)) {
            Notification({
              type: 'error',
              text: `Przepraszamy. Nie udało się wgrać pliku: ${file.name}`,
            }).show();
          }

          if (err.response && (!err.response.status || err.response.status === 400)) {
            Notification({
              type: 'error',
              text: `Przepraszamy. Nie udało się wgrać pliku: ${file.name}`,
            }).show();
          }

          if (err.response && (!err.response.status || err.response.status === 401)) {
            Notification({
              type: 'error',
              text: 'Nie masz uprawnień do wgrania pliku',
            }).show();
          }

          const index = this.state.files.findIndex((item) => item.uid === uid);

          let oldFile = { ...this.state.files[index] };
          oldFile = {
            ...oldFile,
            status: 'error',
          };

          const fs = [...this.state.files];

          fs[index] = oldFile;

          this.removeFiles();
        });
    });

    if (this.props.multiple === true) {
      return this.setState({
        files: [...this.state.files, ...newFiles],
      });
    }

    if (this.actualFileId && !this.actualLogoAlreadyDeleted) {
      this.removeFile(null, null, this.actualFileId, true);
    }
    this.state.files.map((file) => this.removeFile(null, null, file.fileId, true));

    this.setState({
      files: [...newFiles],
    });
  }

  setFiles = (files) => {
    this.setState({
      files,
    });
  };

  removeFile(e = null, uid = null, fileId = null, oldFileId = false, deleteCallback = false) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
      e.nativeEvent.stopImmediatePropagation();
    }

    const index = this.state.files.findIndex((item) => item.uid === uid);
    const file = this.state.files[index];

    const preview = document.getElementById(`file-preview-${this.logoType}`);
    if (preview) preview.setAttribute('src', '');
    fileId = fileId ?? file.fileId;

    deleteFile(this.props.url + '/' + fileId, {})
      .then(async () => {
        this.showLogoFromFileId = false;
        if (this.actualFileId === fileId) this.actualLogoAlreadyDeleted = true;
        Notification({
          type: 'success',
          text: oldFileId ? 'Poprzedni plik został usunięty' : 'Plik został usunięty',
        }).show();
        this.setState({
          files: this.state.files.filter((file) => file.uid !== uid),
        });
        if (deleteCallback && fileId) this.props.deleteCallback(fileId);
      })
      .catch((err) => {
        if (!err.response || (err.response && err.response.status === 500)) {
          Notification({
            type: 'error',
            text: `Przepraszamy. Nie udało się usunąć pliku`,
          }).show();
        }
      });
  }

  removeFiles() {
    this.setState({
      files: [],
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.onRemoveFile !== this.props.onRemoveFile) {
      this.removeFiles();
    }
  }

  render() {
    const { className, text, textAfterUpload, multiple, label, error, maxFiles, isNewUI, labelButton } = this.props;
    const classList = `dropzone ${isNewUI ? 'without-cursor' : ''} ${className} ${error ? 'error' : ''}`;

    return (
      <Fragment>
        <ReactDropzone
          onDrop={this.onDrop}
          multiple={multiple}
          maxFiles={maxFiles}
          noClick={isNewUI}
          noKeyboard={isNewUI}
          disabled={!isNewUI && this.state.files.length === 1 && !multiple}
        >
          {({ getRootProps, getInputProps, open }) => (
            <div {...getRootProps({ className: classList })}>
              <input name='files' {...getInputProps()} />
              <div className='content-container'>
                <span className='font-icon font-icon-upload' />

                {isNewUI && this.actualFileId && this.state.files.length === 0 && this.showLogoFromFileId && !this.actualLogoAlreadyDeleted && (
                  <span>
                    <img src={`${appFsoBackendUrl}/api/frontend/automatic-integration/logo/${this.actualFileId}`} style={{ maxWidth: '200px' }} />
                  </span>
                )}
                {!isNewUI && (
                  <span
                    /* eslint-disable-next-line react/no-danger */
                    dangerouslySetInnerHTML={{
                      __html: this.state.files.length && textAfterUpload.length ? textAfterUpload : text,
                    }}
                  />
                )}

                {isNewUI && !this.actualFileId && (
                  <span
                    /* eslint-disable-next-line react/no-danger */
                    dangerouslySetInnerHTML={{
                      __html: text,
                    }}
                  />
                )}
              </div>
              {!isNewUI && this.state.files.map((f) => <UploaderFile key={f.uid} {...f} removeFile={this.removeFile} />)}
              {isNewUI && (
                <Fragment>
                  <div className='integration__uploader--preview'>
                    {this.state.files.map((f, index) => (
                      <img key={index} id={`file-preview-${this.logoType}`} style={{ maxWidth: '200px' }} />
                    ))}
                    <div>
                      {this.state.files.map((f) => (
                        <UploaderFile key={f.uid} {...f} removeFile={this.removeFile} isNewUi />
                      ))}
                    </div>
                  </div>

                  <div key={label} className='integration__uploader--center'>
                    <span className='label'>{label}</span>

                    <div className='integration__uploader--buttons'>
                      <button
                        className='integration__uploader--button'
                        type='button'
                        onClick={open}
                      >
                        <IconPlus />
                        {labelButton}
                      </button>
                      {this.state.files.map((f) => (
                        <button key={f.uid} type='button' className='integration__uploader--button' onClick={(e) => this.removeFile(e, f.uid)}>
                          <BinIcon />
                          <FormattedMessage id='Remove' />
                        </button>
                      ))}
                      {this.actualFileId && this.state.files.length === 0 && this.showLogoFromFileId && !this.actualLogoAlreadyDeleted && (
                        <button key={this.actualFileId} type='button' className='integration__uploader--button' onClick={(e) => this.removeFile(e, null, this.actualFileId)}>
                          <BinIcon />
                          <FormattedMessage id='Remove' />
                        </button>
                      )}
                    </div>
                  </div>
                </Fragment>
              )}
            </div>
          )}
        </ReactDropzone>
        {!isNewUI && (
          <div>
            <span className='label'>{label}</span>
          </div>
        )}
      </Fragment>
    );
  }
}

Dropzone.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  textAfterUpload: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  className: PropTypes.oneOf([null, 'primary-canvas', 'secondary-canvas']),
  multiple: PropTypes.bool,
  fieldName: PropTypes.string,
  uploadCallback: PropTypes.func,
  error: PropTypes.bool,
  uploadParams: PropTypes.object,
  deleteCallback: PropTypes.func,
  isNewUI: PropTypes.bool,
};

Dropzone.defaultProps = {
  className: 'primary-canvas',
  multiple: false,
  fieldName: 'customerLogo',
  textAfterUpload: '',
  error: false,
  uploadCallback: () => {},
  deleteCallback: () => {},
  isNewUI: false,
};

export default Dropzone;
